export default "__VITE_ASSET__BBfb0pX2__"